import React, { useState } from 'react';
import { Bell, Check } from 'lucide-react';

const toggleGroups = [
  {
    label: 'Activity',
    items: [
      { key: 'rideUpdates', label: 'Ride Updates', desc: 'Driver assigned, pickup, dropoff' },
      { key: 'deliveryUpdates', label: 'Delivery Notifications', desc: 'Package picked up, in transit, delivered' },
      { key: 'promotions', label: 'Promotions & Offers', desc: 'Discounts, promo codes, special deals' },
    ],
  },
  {
    label: 'Channels',
    items: [
      { key: 'sms', label: 'SMS Notifications', desc: 'Receive alerts via text message' },
      { key: 'email', label: 'Email Notifications', desc: 'Receive alerts via email' },
      { key: 'push', label: 'Push Notifications', desc: 'Browser & app push alerts' },
    ],
  },
];

const NotificationPreferences = ({ preferences, onSave }) => {
  const [prefs, setPrefs] = useState({
    rideUpdates: true,
    deliveryUpdates: true,
    promotions: false,
    sms: true,
    email: true,
    push: true,
    ...preferences,
  });
  const [saved, setSaved] = useState(false);

  const handleToggle = (key) => {
    setPrefs(prev => ({ ...prev, [key]: !prev?.[key] }));
    setSaved(false);
  };

  const handleSave = async () => {
    try {
      await onSave?.(prefs);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      console.error('Failed to save preferences:', err);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Bell className="w-4 h-4 text-[#1a365d]" />
          <h3 className="font-semibold text-[#1a365d]">Notification Preferences</h3>
        </div>
        <button
          onClick={handleSave}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
            saved
              ? 'bg-green-100 text-green-700' :'bg-[#1a365d] text-white hover:bg-[#2d5a87]'
          }`}
        >
          {saved ? <><Check className="w-3.5 h-3.5" /> Saved</> : 'Save'}
        </button>
      </div>
      <div className="p-5 space-y-5">
        {toggleGroups?.map(group => (
          <div key={group?.label}>
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">{group?.label}</p>
            <div className="space-y-3">
              {group?.items?.map(({ key, label, desc }) => (
                <div key={key} className="flex items-center justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-slate-800">{label}</p>
                    <p className="text-xs text-slate-500 truncate">{desc}</p>
                  </div>
                  <button
                    onClick={() => handleToggle(key)}
                    className={`relative w-11 h-6 rounded-full transition-colors flex-shrink-0 ${prefs?.[key] ? 'bg-[#1a365d]' : 'bg-slate-200'}`}
                  >
                    <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${prefs?.[key] ? 'translate-x-5' : 'translate-x-0'}`} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPreferences;
